let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvKCj")).then(() => parcelRequire('jh0iZ'));